import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { StatoServizio } from "@/hooks/useAgenteSalute";

export interface SaluteDot {
  id: string;
  stato: StatoServizio;
  label: string;
}

export interface NotificaItem {
  tipo: string;
  severita: "err" | "warn" | "info";
  titolo: string;
  dettaglio: string;
  link: string;
}

export function useAdminSalute() {
  return useQuery({
    queryKey: ["admin", "salute"],
    queryFn: () =>
      apiFetch<{ servizi: SaluteDot[]; queried_at: string }>("/api/v1/admin/salute"),
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}

export function useAdminNotifiche() {
  return useQuery({
    queryKey: ["admin", "notifiche"],
    queryFn: () =>
      apiFetch<{ notifiche: NotificaItem[]; totale: number }>("/api/v1/admin/notifiche"),
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
